import { html, nothing } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { type TefComsConsent } from '@src/components/tef-coms-consent.js';
import { doToggle, localDate, localTime } from '@src/components/templates/util.js';
import { ConsentType } from '@src/types/common.js';

export const consentTemplate = (
  consentClasses: string[],
  checkboxClasses: string[],
  consent: ConsentType,
  disabled: boolean,
  comsConsent: TefComsConsent,
) => {
  const iconType = consent.granted ? 'check' : 'cross';
  const shouldDisplayLastChange = consent.clientDisplay && localDate(consent.date);

  const lastChangeAtHtml = html`
    <small>
      <tef-coms-icon icon="clock"></tef-coms-icon>
      Letzte Änderung am ${localDate(consent.date)} um ${localTime(consent.date)} Uhr über ${consent.clientDisplay}
    </small>`;

  const checkboxHtml = html`
    <div class="${checkboxClasses.join(' ')}">
      <input
        type="checkbox"
        .checked=${consent.granted}
        @click="${doToggle({ id: consent.id })}"
        id="${consent.id}"
        name="${consent.id}"
      >
      <label for=${consent.id}>
        ${unsafeHTML(consent.scope)}
      </label>
    </div>`;

  const iconHtml = html`
    <div>
      <tef-coms-icon .icon="${iconType}" size="l"></tef-coms-icon>
      <span>
         ${unsafeHTML(consent.scope)}
      </span>
    </div>`;

  let consentHtml;
  if (disabled) {
    consentHtml = iconHtml;
  } else if (comsConsent.isDisplayModeText() || comsConsent.isDisplayModeList()) {
    consentHtml = html`<div>${unsafeHTML(consent.scope)}</div>`;
  } else {
    consentHtml = checkboxHtml;
  }

  return html`
    <div class="${consentClasses.join(' ')}">
      ${consent.hintBefore ? html`<div class="coms-hint-before">${unsafeHTML(consent.hintBefore)}</div>` : nothing}
      ${consentHtml}
      ${comsConsent.features}
      ${consent.hintAfter ? html`<div class="coms-hint-after">${unsafeHTML(consent.hintAfter)}</div>` : nothing}
    </div>
    ${shouldDisplayLastChange ? lastChangeAtHtml : nothing}`;
};
